export enum ApiNotificationsUrls {
  Notifications = '/saas/v1.0/notifications',
}

export enum NotificationEvents {
  SPO_VO_ALLOW = 'OnboardingSpoVpo',
  NEW_SPO_VO_ALLOW = 'NewProgramsSpoVo',
  HOLIDAYS_ALLOW = 'SchoolYearEnds',
}
